import { nextMonth, today } from "./helpers/dates";

export const setSessionStorage = (key, value) =>
  sessionStorage.setItem(key, JSON.stringify(value));

export const getSessionStorage = (key) =>
  JSON.parse(sessionStorage.getItem(key));

export const setLocalStorage = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value));

export const getLocalStorage = (key) => JSON.parse(localStorage.getItem(key));

export const resetSessionStorage = () => {
  sessionStorage.removeItem("state");
  sessionStorage.removeItem("appraisalSessionId");
};

export const clearStorageForNewAppraisal = () => {
  setLocalStorage("appraisalsData", {});
  setSessionStorage("state", {});
}

export const setLocalStorageDataForAppraisalReuse = (valuation, vehicle, isSavedDealReappraisal) => {
  if (isSavedDealReappraisal) return
  if (valuation?.valuation > 0) {
    const storedState = getSessionStorage("state") || {};
    const formatData = {
      mileageExpiredDate: today,
      expiredDate: nextMonth,
      appraisal: storedState.appraisal,
      vehicle
    };
    setLocalStorage("appraisalsData", formatData);
  }
};
